<script lang="ts">
  import type { ButterflyAPI, ButterflyPost, ButterflyAuthor, ButterflyMedia } from '$lib/types';
  import { formatDistance } from 'date-fns';
  import fr from 'date-fns/locale/fr/index.js';
  import getRelation from '$lib/getRelation';
  import getMediaUrl from '$lib/getMediaUrl';
  import Image from './BodyElements/Image.svelte';
  import Video from './BodyElements/Video.svelte';

  export let withThumb = false;
  export let withAuthorship = true;
  export let post: ButterflyAPI<ButterflyPost>;
  const authors: ButterflyAuthor[] =
    post.data.relationships.authors.data?.map((author) => getRelation(author, post.included)) ?? [];
  const media: ButterflyMedia | null = post.data.relationships.thumbnail.data?.id
    ? getRelation(post.data.relationships.thumbnail.data, post.included)
    : null;
</script>

<header>
  <h1 class="post--title pb4">{post.data.attributes.title}</h1>
  <p class="post--resume">{post.data.attributes.resume}</p>
  {#if withAuthorship}
    <div class="d-flex g2 pt2 fs-brevier">
      {#if authors.filter((a) => a.relationships.thumbnail.data).length}
        <div class="post--authors-avatar d-flex">
          {#each authors.filter((a) => a.relationships.thumbnail.data) as author, i}
            {#if author.relationships.thumbnail.data}
              <div class="d-flex ai-center">
                <img
                  class="bar-circle ba bc-light"
                  class:mln2="{i > 0}"
                  width="32"
                  height="32"
                  src="{getMediaUrl(
                    getRelation(author.relationships.thumbnail.data, post.included),
                    {
                      format: 'square',
                      ext: 'jpg',
                      width: 32,
                    },
                  )}"
                  alt="{author.attributes.name}"
                />
              </div>
            {/if}
          {/each}
        </div>
      {/if}
      <div>
        <div class="post--date">
          <span class="post--published-at"
            >Publié il y a <time datetime="{post.data.attributes.publishedAt}"
              >{formatDistance(new Date(post.data.attributes.publishedAt), new Date(), {
                locale: fr,
              })}</time
            ></span
          >{#if post.data.attributes.publishedAt < post.data.attributes.updatedAt},
            <span class="post--updated-at"
              >mis à jour il y a <time datetime="{post.data.attributes.updatedAt}"
                >{formatDistance(new Date(post.data.attributes.updatedAt), new Date(), {
                  locale: fr,
                })}</time
              ></span
            >
          {/if}
        </div>
        <div class="post--authors">
          {#if authors.length}
            Par
            {#each authors as author, i}
              <a href="/authors/{author.id}">{author.attributes.name}</a
              >{#if i === authors.length - 2} and {:else if i !== authors.length - 1}, {/if}
            {/each}
          {/if}
        </div>
      </div>
    </div>
  {/if}

  {#if withThumb && media}
    <figure class="post--media">
      {#if media.type === 'image'}
        <Image
          class="post--thumbnail pt4"
          data="{{ mediaId: media.id }}"
          included="{post.included}"
          lazyload="{false}"
        />
      {:else if media.type === 'video'}
        <Video
          class="post--thumbnail pt4"
          data="{{ mediaId: media.id }}"
          included="{post.included}"
        />
      {/if}
      {#if media.attributes.description?.length || media.attributes.credits?.length}
        <figcaption class="post--media--desc">
          {media.attributes.description}
          {#if media.attributes.description?.length && media.attributes.credits?.length}
            &nbsp;—&nbsp;
          {/if}
          {#if media.attributes.credits?.length}
            <span class="post--media--credits">{media.attributes.credits}</span>
          {/if}
        </figcaption>
      {/if}
    </figure>
  {/if}
</header>
